<template>
  <font-awesome-icon
    :icon="{ prefix: 'fab', iconName: 'instagram' }" />
</template>
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'

library.add(faInstagram)

export default {
  name: 'CoozzyInstagramIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-yellow;
  }
</style>
